export const url = '/pnrDetails';
export const Provider = 'PnrDetails';
export const TABLE_NAME = 'pnrdetails';
